// All editable site content lives here for easy updates.
export const CONTACT = {
  phone: "984-242-1690",
  phoneRaw: "+19842421690",
  email: "carswithmalcolm@gmail.com",
  smsBody: "Hi Malcolm, I'd like some help with a vehicle.",
};

export const BRAND = {
  name: "Cars With Malcolm",
  tagline: "Raleigh Automotive Liaison",
  person: "Malcolm Burke",
  role: "Car Sales Professional",
  serving: "Serving Raleigh, NC and surrounding areas",
  website: "www.carswithmalcolm.com",
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_cars-malcolm-build/artifacts/3wvtuwty_CWM2.png",
  headshot: "https://customer-assets.emergentagent.com/job_cars-malcolm-build/artifacts/rkeo26tm_mal%20headshot.png",
};

export const LINKS = {
  newInventory: "https://www.nissanofraleigh.com/new-inventory/index.htm",
  usedInventory: "https://www.nissanofraleigh.com/used-inventory/index.htm",
  allInventory: "https://www.nissanofraleigh.com/all-inventory/index.htm",
  fastLane: "https://www.nissanofraleigh.com/fred-anderson-fast-lane.htm",
  financing: "https://www.nissanofraleigh.com/financing/index.htm",
};

export const IMAGES = {
  heroBg: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbHV4dXJ5JTIwY2FyJTIwaW50ZXJpb3IlMjBzdHVkaW98ZW58MHx8fHwxNzgyMzUyNjg4fDA&ixlib=rb-4.1.0&q=85",
  finalCtaBg: "https://images.unsplash.com/photo-1763296840082-cac05bc18337?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxuZXclMjBuaXNzYW4lMjBjYXIlMjBkZWFsZXJzaGlwJTIwc2hvd3Jvb20lMjBkYXJrfGVufDB8fHx8MTc4MjM1Mjc1Mnww&ixlib=rb-4.1.0&q=85",
  newInventory: "https://images.pexels.com/photos/7629190/pexels-photo-7629190.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  usedInventory: "https://images.pexels.com/photos/7395259/pexels-photo-7395259.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  trophy: "https://static.prod-images.emergentagent.com/jobs/b95e080d-7453-4f70-903b-41ad5dbc3db9/images/6e413174038b6a970df0d60c165f83a2cc7c81f47337f8c3eed5ba9c77fc1c02.png",
  handshake: "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBrZXlzJTIwaGFuZHNoYWtlJTIwZGVhbHxlbnwwfHx8fDE3ODIzNTI3NTJ8MA&ixlib=rb-4.1.0&q=85",
};

export const STATS = [
  { value: "1,000+", label: "Vehicles Sold" },
  { value: "20+", label: "Salesperson Awards" },
  { value: "2022–2025", label: "Award of Excellence" },
  { value: "4 Gears", label: "Recognition Award" },
];

export const HERO_BADGES = [
  "Raleigh Automotive Liaison",
  "1,000+ vehicles sold",
  "Good credit & bad credit guidance",
  "Personal, Uber, and business vehicle help",
];

export const AWARD_DATES = [
  "Sales Associate of the Year 2020",
  "Sales Associate of the Month · Jan 2021",
  "Sales Associate of the Month · Mar 2021",
  "Sales Associate of the Month · Apr 2021",
  "Sales Associate of the Month · Jun 2022",
  "Sales Associate of the Month · Sep 2022",
  "Sales Associate of the Month · Dec 2022",
  "Sales Associate of the Month · Nov 2023",
  "Award of Excellence 2022",
];

export const AWARD_HIGHLIGHTS = [  { value: "1,000+", label: "Vehicles sold in the last 4.5 years" },
  { value: "2022–2025", label: "Award of Excellence" },
  { value: "20+", label: "Salesperson of the Month awards" },
  { value: "4 Gears", label: "Recognition Award" },
];

export const DIFFERENCE_BULLETS = [
  "Good credit and bad credit guidance",
  "First-time buyer support",
  "Trade-in guidance",
  "Uber and rideshare vehicle help",
  "Business and fleet vehicle conversations",
  "Personal attention from start to finish",
];

export const HELP_CARDS = [
  {
    icon: "CircleCheckBig",
    title: "Good Credit Buyers",
    copy: "If you have strong credit and want a smoother process, Malcolm can help you prepare, compare options, and move efficiently.",
  },
  {
    icon: "TrendingUp",
    title: "Bad Credit Buyers",
    copy: "If your credit is not perfect, Malcolm can help you understand possible paths forward and what information may be needed.",
  },
  {
    icon: "Car",
    title: "Uber & Rideshare",
    copy: "Need a vehicle for Uber, Lyft, or other rideshare work? Malcolm can help you think through reliability, comfort, cost, and business use.",
  },
  {
    icon: "Briefcase",
    title: "Business & Fleet Help",
    copy: "If you need vehicles for business or fleet use, Malcolm can help start the conversation and guide you toward the right next step.",
  },
  {
    icon: "UserRound",
    title: "First-Time Buyers",
    copy: "Malcolm helps first-time buyers understand the process, what to bring, and what to expect.",
  },
  {
    icon: "Repeat",
    title: "Trade-In Guidance",
    copy: "Malcolm can help you understand the trade-in process and what to have ready before you come in.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I had a great experience at Fred Anderson Nissan buying my 2025 Kicks! Malcolm was fantastic—super responsive, willing to work with me on the details, and ultimately won me over after visiting countless other car lots. They made the process smooth and stress-free, and I never felt pressured. Highly recommend working with them if you're in the market for a new ride!",
    name: "Hannah R.",
    source: "Google",
  },
  {
    quote:
      "Finance Manager Malcolm Burke's professionalism and friendly customer service had 100% to do with my stopping by and purchasing on the same day.",
    name: "Chuck W.",
    source: "Cars.com",
  },
  {
    quote:
      "Malcolm is FANTASTIC! He deserves a raise! Higher-ups, if you're reading this, I hope you know how blessed you are to have him working at your dealership.",
    name: "Christopher L.",
    source: "DealerRater",
  },
  {
    quote:
      "Malcolm was awesome! We had another great buying experience. As a loyal Nissan customer they never fail at outstanding customer service and support!",
    name: "Robyn H.",
    source: "Google",
  },
];

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Awards", href: "#awards" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const NEED_OPTIONS = [
  "Buying a car",
  "Good credit purchase",
  "Bad credit / rebuilding credit",
  "First-time buyer",
  "Trade-in",
  "Uber / rideshare vehicle",
  "Business vehicle",
  "Fleet management",
  "Family vehicle",
  "Not sure yet",
];
